const FIELD_PREFIX = 'vsb'
const PUBLIC_ID = 1

export function getVisibility(responseBody, blacklist = []){
  const keys = Object.keys(responseBody)

  const filtered = keys.filter(key => !blacklist.includes(key))
  const visibilityKeys = filtered.filter(key => key.slice(0, 3) === FIELD_PREFIX )

  const visibility = {}
  const visibilityIdOnly = {}
  let isAllPublic = true
  let isPrivate = true

  for (let index = 0; index < visibilityKeys.length; index++) {
    const key = visibilityKeys[index];
    visibility[key] = responseBody[key]
    visibilityIdOnly[key] = responseBody[key]?.id

    if(responseBody[key] && responseBody[key].id !== PUBLIC_ID){
      isAllPublic = false
    } else {
      isPrivate = false
    }
  }

  return { visibility, visibilityKeys, visibilityIdOnly, isAllPublic, isPrivate }
}
